export const ROUTER_NAMES = {
  HOME: 'home',
  PRESET_FILTERS: 'filtersPreset',
  ASSESSMENT_DETAIL_PAGE: 'assessment',
  UNAUTHORIZED: 'unauthorized',
  DEV_TOOLS: 'devTools',
  ERROR: 'error'
}
